import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Admin from './Admin';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
 const path = window.location.pathname; // Gets "/admin" or "/"
  const admin= (path === "/admin");



root.render(
  <React.StrictMode>
    {admin?<Admin/>:<App/>}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
